import { Children, Fragment } from 'react';

import { StyledListContainer, StyledListDot } from './ListHorizontal.styled';

const ListHorizontal = ({
	children,
	...props
}: React.HTMLAttributes<HTMLDivElement>) => {
	const childrenArray = Children.toArray(children);

	return (
		<StyledListContainer {...props}>
			{childrenArray.map((child, index) => (
				<Fragment key={`child#${index}`}>
					{index > 0 && <StyledListDot />}
					{child}
				</Fragment>
			))}
		</StyledListContainer>
	);
};

export { ListHorizontal };
